import BaseApi from '@/api/Base/BaseApi'

import {
  ModelPipelineResultNodeInfo,
  ModelPipelineResultNodeItemListResponse,
  UpdateModelPipelineResultNodePayload
} from '@/api/ModelPipelineResultNode/types'
import { CommonListPayload } from '@/api/Node/types'

// FIXME: root
const ROOT = '/model-pipeline-result'

const defaultPaginationOptions = {
  itemsPerPage: 40,
  page: 0,
  sortDir: 'desc',
  sortKey: 'createdAt',
}

export default class ModelPipelineResultNodeApi extends BaseApi {
  getModelPipelineResultNode(modelPipelineResultNodeId: string) {
    return this.agent.get<ModelPipelineResultNodeInfo>(`${ROOT}/${modelPipelineResultNodeId}`)
  }

  getModelPipelineResultItems(modelPipelineResultNodeId: string, options?: CommonListPayload) {
    const { itemsPerPage, page, sortDir, sortKey } = options ?? defaultPaginationOptions
    return this.agent.get<ModelPipelineResultNodeItemListResponse>(`${ROOT}/${modelPipelineResultNodeId}/items`, {
      params: {
        page,
        num_per_page: itemsPerPage,
        sort_key: sortKey,
        sort_dir: sortDir,
      },
    })
  }

  updateModelPipelineResultNode(payload: UpdateModelPipelineResultNodePayload) {
    const { modelPipelineResultNodeId, ...rest } = payload
    return this.agent.put(`${ROOT}/${modelPipelineResultNodeId}`, rest)
  }
}
